var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiFloorPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 13.9115V27.3628H24V13.9115H13.3333V35.4336H24V32.7433H26.6667V46.1947H24V38.1239H13.3333V51.5752H32V46.1947H34.6667V51.5752H50.6667V46.1947H56V56.9557H8V8.53094H56V40.8141H50.6667V27.3628H34.6667V40.8141H32V24.6725H50.6667V13.9115H26.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiFloorPlan);
export default __webpack_public_path__ + "static/media/mdi_floor-plan.0e9ef36ec5031b0198d3877adb46b55c.svg";
export { ForwardRef as ReactComponent };